<ng-container>
    <section class="table-wrapper">
        <table class="table">
            <thead class="table-head">
                <tr class="th-row">
                    <th class="th-data" (click)="sortData('generatedLoanId')">
                        <div class="title-group pointer">
                            <span>FINL</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <th class="th-data">
                        <div class="title-group pointer" (click)="sortData('investedAmount')">
                            <span>Total Investment in Loan</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <th class="th-data" (click)="sortData('grossCashFlowReceivedBeforeSettlement')">
                        <div class="title-group pointer">
                            <span>Gross Cashflow Received Before Settlement</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
    
                    <th class="th-data" (click)="sortData('principalOutstandingBeforeSettlement')">
                        <div class="title-group pointer">
                            <span>Principal Outstanding Before Settlement</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
    
                    <th class="th-data" (click)="sortData('settlementAmountOffered')">
                        <div class="title-group pointer">
                            <span>Settlement Amount Offered</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
    
                    <th class="th-data" (click)="sortData('grossCashFlowReceivedPostSettlement')">
                        <div class="title-group pointer">
                            <span>Gross Cashflow Received Post Settlement</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
    
                    <th class="th-data last-column" (click)="sortData('settlementNegotiationStatus')">
                        <div class="title-group pointer">
                            <span>Action/Status</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
    
                </tr>
            </thead>
            <tbody class="table-body">
                <tr class="tb-row" *ngFor="let element of visibleData">
                    <td class="tb-data">{{element.generatedLoanId}}</td>
                    <td class="tb-data">{{element.investedAmount | number : '1.2-2'}}</td>
                    <td class="tb-data">{{element.grossCashFlowReceivedBeforeSettlement | number : '1.2-2'}}</td>
                    <td class="tb-data">{{element.principalOutstandingBeforeSettlement | number : '1.2-2'}}</td>
                    <td class="tb-data">{{element.settlementAmountOffered | number : '1.2-2'}}</td>
                    <td class="tb-data">{{element.grossCashFlowReceivedPostSettlement | number : '1.2-2'}}</td>
                    <td class="tb-data last-column"
                        [ngClass]="{'center-text': element.settlementNegotiationStatus !== '' && element.settlementNegotiationStatus !== null}">
                        <ng-container
                            *ngIf="element.settlementNegotiationStatus === '' || element.settlementNegotiationStatus === null || element.settlementNegotiationStatus === loanSettlementNegotiationStatus.PENDING">
                            <div class="d-flex flex-wrap justify-content-between align-items-center">
                                <button (click)="actionButtonHandler(loanSettlementNegotiationStatus.ACCEPTED, element)"
                                    mat-stroked-button class="mx-1 my-1 custom-button custom-button-primary">Accept</button>
                                <button (click)="actionButtonHandler(loanSettlementNegotiationStatus.REJECTED, element)"
                                    mat-stroked-button class="mx-1 my-1 custom-button custom-button-danger">Reject</button>
                                <button (click)="actionButtonHandler(loanSettlementNegotiationStatus.IN_PROGRESS, element)"
                                    mat-stroked-button class="mx-1 my-1 modify custom-button-warning">Negotiate</button>
                            </div>
                        </ng-container>
                        <ng-container
                            *ngIf="element.settlementNegotiationStatus === loanSettlementNegotiationStatus.ACCEPTED">
                            <div class="d-flex">
                                <mat-icon matSuffix class="text-success">check_circle</mat-icon>
                                <span class="font-bold mt-1">Accepted</span>
                            </div>
                        </ng-container>
                        <ng-container
                            *ngIf="element.settlementNegotiationStatus === loanSettlementNegotiationStatus.REJECTED">
                            <div class="d-flex">
                                <mat-icon class="text-danger">cancel</mat-icon>
                                <span class="font-bold mt-1">Rejected</span>
                            </div>
                        </ng-container>
                        <ng-container
                            *ngIf="element.settlementNegotiationStatus === loanSettlementNegotiationStatus.IN_PROGRESS">
                            <div class="d-flex">
                                <mat-icon class="text-warning">sync</mat-icon>
                                <span class="font-bold mt-1">Negotiation in progress</span>
                            </div>
                        </ng-container>
                    </td>
    
    
                </tr>
            </tbody>
        </table>
    </section>
    
    <!-- MOBILE SCREEN PORTION STARTS -->
    <article class="responsive-table">
        <mat-accordion>
            <section class="header-table text-dark">
                <div class="header-cell col-min-width loanId-col-width">
                    <div class="title-group pointer ">
                        <span>FINL</span>
                        <div class="sort-group">
                            <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                            <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                        </div>
                    </div>
                </div>
    
                <div class="header-cell">
                    <div class="title-group invest-max-width pointer">
                        <span>Status</span>
                        <div class="sort-group">
                            <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                            <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                        </div>
                    </div>
                </div>
            </section>
            <section class="body-table">
                <mat-expansion-panel *ngFor="let element of visibleData;" class="expansion-panel">
                    <mat-expansion-panel-header class="expansion-panel-header">
                        <div class="body-cell loanId-margin col-min-width">
                            <div class="data-text">
                                <span>{{element.generatedLoanId}}</span>
                            </div>
                        </div>
    
                        <div class="body-cell">
                            <div class="data-text">
                                <ng-container
                                    *ngIf="element.settlementNegotiationStatus === '' || element.settlementNegotiationStatus === null || element.settlementNegotiationStatus === loanSettlementNegotiationStatus.PENDING">
                                    N/A
                                </ng-container>
                                <ng-container
                                    *ngIf="element.settlementNegotiationStatus === loanSettlementNegotiationStatus.ACCEPTED">
                                    <span class="font-bold text-success">Accepted</span>
                                </ng-container>
                                <ng-container
                                    *ngIf="element.settlementNegotiationStatus === loanSettlementNegotiationStatus.REJECTED">
                                    <span class="font-bold text-danger">Rejected</span>
                                </ng-container>
                                <ng-container
                                    *ngIf="element.settlementNegotiationStatus === loanSettlementNegotiationStatus.IN_PROGRESS">
                                    <span class="font-bold text-color-finzy-orange">Negotiation in Progress</span>
                                </ng-container>
                            </div>
                        </div>
                    </mat-expansion-panel-header>
                    <mat-panel-description class="description-panel">
    
                        <div class="my-3 text-center w-100 p-2">
                            <table style="width: 100%;">
                                <tr>
                                    <th class="py-3">FINL</th>
                                    <td class="py-3 text-right">{{ element.generatedLoanId }}</td>
                                </tr>
                                <tr>
                                    <th class="py-3">Total Investment in Loan</th>
                                    <td class="py-3 text-right">{{ element.investedAmount | number : '1.2-2'}}</td>
                                </tr>
                                <tr>
                                    <th class="py-3">Gross Cashflow Received Before Settlement</th>
                                    <td class="py-3 text-right">{{ element.grossCashFlowReceivedBeforeSettlement | number : '1.2-2'}}</td>
                                </tr>
                                <tr>
                                    <th class="py-3">Principal Outstanding Before Settlement</th>
                                    <td class="py-3 text-right">{{ element.principalOutstandingBeforeSettlement | number : '1.2-2'}}</td>
                                </tr>
                                <tr>
                                    <th class="py-3">Settlement Amount Offered</th>
                                    <td class="py-3 text-right">{{ element.settlementAmountOffered | number : '1.2-2'}}</td>
                                </tr>
                                <tr>
                                    <th class="py-3">Gross Cash Received Post Settlement</th>
                                    <td class="py-3 text-right">{{ element.grossCashFlowReceivedPostSettlement | number : '1.2-2'}}</td>
                                </tr>
    
                                <tr>
                                    <th class="py-3">Status</th>
                                    <td class="tb-data last-column-responsive py-3 text-right"
                                        [ngClass]="{'center-text': element.settlementNegotiationStatus !== '' && element.settlementNegotiationStatus !== null}">
                                        <ng-container
                                            *ngIf="element.settlementNegotiationStatus === '' || element.settlementNegotiationStatus === null || element.settlementNegotiationStatus === loanSettlementNegotiationStatus.PENDING">
                                            <div class="d-flex flex-wrap justify-content-end align-items-center">
                                                <button
                                                    (click)="actionButtonHandler(loanSettlementNegotiationStatus.ACCEPTED, element)"
                                                    mat-stroked-button
                                                    class="mx-1 my-1 custom-button custom-button-primary">Accept</button>
                                                <button
                                                    (click)="actionButtonHandler(loanSettlementNegotiationStatus.REJECTED, element)"
                                                    mat-stroked-button
                                                    class="mx-1 my-1 custom-button custom-button-danger">Reject</button>
                                                <button
                                                    (click)="actionButtonHandler(loanSettlementNegotiationStatus.IN_PROGRESS, element)"
                                                    mat-stroked-button
                                                    class="mx-1 my-1 modify custom-button-warning">Negotiate</button>
                                            </div>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="element.settlementNegotiationStatus === loanSettlementNegotiationStatus.ACCEPTED">
                                            <span class="font-bold text-success">Accepted</span>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="element.settlementNegotiationStatus === loanSettlementNegotiationStatus.REJECTED">
                                            <span class="font-bold text-danger">Rejected</span>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="element.settlementNegotiationStatus === loanSettlementNegotiationStatus.IN_PROGRESS">
                                            <span class="font-bold text-color-finzy-orange">Negotiation in Progress</span>
                                        </ng-container>
                                    </td>
                                </tr>
    
                            </table>
                        </div>
    
    
                    </mat-panel-description>
                </mat-expansion-panel>
            </section>
        </mat-accordion>
    </article>
    
    <mat-paginator [pageSize]="itemsPerPage" [pageSizeOptions]="[5, 10, 20]" (page)="onPageChange($event)"
        [length]="tableData.length">
    </mat-paginator>
</ng-container>
